import Sdk from './sdk.srv';
import sdkEventTriggerDirectiveFactory from './sdk-event-trigger.drv';

angular.module('sdk', ['core', 'auth'])
	.service('sdk', Sdk)
	.directive('sdkEventTrigger', sdkEventTriggerDirectiveFactory);
